<script>
	let routeContext = require('core/routeContext');
	let crudService = require('services/crudService');

	module.exports = {
		mounted() {
			this.$subscribe('title-change', this.onTitleChange);
		},
		modelData: ['userContext'],
		data: function () {
			return {
				title: document.title,
				routeContext: routeContext,
				shareDisabled: false,
				showBinderLink: false
			};
		},
		watch: {
			'userContext.eid': {
				handler: function (eid) {
					if (typeof eid !== 'undefined') {
						this.getBinder();
					}
				},
				immediate: true
			}
		},
		computed: {
			lessonsActive: function () {
				return this.routeContext.pathname.indexOf('/lessons') === 0 || this.routeContext.pathname.indexOf('/books') === 0;
			},
			standardsActive: function () {
				return this.routeContext.pathname.indexOf('/user/alignment') === 0;
			},
			binderActive: function () {
				return this.routeContext.pathname.indexOf('/binder') === 0;
			}
		},
		methods: {
			onTitleChange: function (val) {
				this.title = val;
			},
			getBinder: function () {
				let eid = this.userContext && this.userContext.eid;
				if (typeof eid !== 'undefined' && eid !== null && eid !== '') {
					crudService.read('binder').then(entries => {
						if (entries && entries.length) {
							this.showBinderLink = true;
						}
					});
				}
			}
		}
	};
</script>
<style lang="sass">
	@import 'config/colors';

	.lessons-and-units-secondary-nav {
		min-height: 3.8rem;
		background-color: $c-blue-lighter;
		border-bottom: 1px solid $c-grey;
		text-align: center;

		.wrapper {
			min-height: 3.8rem;
			vertical-align: bottom;
			position: relative;

			ul.main-header-nav {
				@media only screen and (min-width: 800px) {
					position: absolute;
					bottom: 0;
					left: 2rem;
					margin-bottom: 0rem;

					>li {
						width: auto !important;
					}
				}

				@media only screen and (min-width: 1140px) {
					left: 0;
					right: 0;
				}

				position: relative;
				margin-bottom: .5rem;

				>li {
					width: 100%;
				}

				margin-left: auto;
				margin-right: auto;

				&.-topics {
					display: inherit;
				}

				&>li>a {

					&.active,
					&:hover {
						color: $c-drupal-green;
						border-color: $c-drupal-green;
					}
				}
			}

			.share-container {
				@media only screen and (min-width: 800px) {
					position: absolute;
					bottom: .8rem;
					margin-bottom: 0rem;
					right: 0;
				}

				position: relative;
				margin-bottom: .5rem;

				.share-buttons {
					padding-bottom: 0;
					margin-bottom: 0;
					border-bottom: none;
				}
			}
		}
	}
</style>
<template>
	<div class="lessons-and-units-secondary-nav main">
		<div class="wrapper">
			<ul class="main-header-nav -topics row">
				<li>
					<a
						href="/lessons-and-units"
						:class="lessonsActive ? 'active' : ''">
						Lessons &amp; Units
					</a>
				</li>
				<li v-if="showBinderLink">
					<a
						href="/binder"
						:class="binderActive ? 'active' : ''">
						My Binder
					</a>
				</li>
			</ul>
			<div :class="['share-container', shareDisabled ? 'disabled' : '']">
				<share-buttons
					v-if="userContext"
					no-querystring
					:event-data="{ tag: 'lessons_and_units' }"
					:share-title="title">
				</share-buttons>
			</div>
		</div>
	</div>
</template>
